(function (global) {
  'use strict';

  const STATUS = Object.freeze({
    AUTO: 'AUTO_SUPPORTED',
    REVIEW: 'MANUAL_REVIEW',
    UNSUPPORTED: 'UNSUPPORTED'
  });

  const SYSTEM_KEY = 'JEREMIAS_DW_ECO_2_0';
  const SYSTEM_LABEL = 'Jeremias DW-ECO 2.0';
  const PRIMARY_DNS = Object.freeze([130, 150, 160, 180, 200]);
  const WALL_DISTANCES_MM = Object.freeze([50, 100, 150, 200, 250, 300, 360]);
  const MAX_HOLDER_SPACING_MM = 4000;
  const MAX_FREE_HEIGHT_MM = 3000;
  const ABSOLUTE_MAX_FREE_HEIGHT_MM = 4000;

  const HEIGHT_CONTRIBUTIONS_MM = Object.freeze({
    basePlate: 110,
    inspection: 370,
    teeSocketDeduction: 60,
    terminal: 80,
    length1000: 938,
    length500: 438,
    length250: 188
  });

  const TEE_DIMENSION_BY_DN_MM = Object.freeze({
    130: 356,
    150: 376,
    160: 386,
    180: 406,
    200: 426
  });

  const FIXED_HEIGHT_BY_DN_MM = Object.freeze({
    130: 856,
    150: 876,
    160: 886,
    180: 906,
    200: 926
  });

  const T_TOP_BY_DN_MM = Object.freeze({
    130: 776,
    150: 796,
    160: 806,
    180: 826,
    200: 846
  });

  const HEIGHT_RECIPES = Object.freeze([
    Object.freeze({ id: 'H1', customerLabel: 'ca. 1,8 m', counts: Object.freeze({ DWETN13: 1, DWETN14: 0, DWETN15: 0 }) }),
    Object.freeze({ id: 'H2', customerLabel: 'ca. 2,3 m', counts: Object.freeze({ DWETN13: 1, DWETN14: 1, DWETN15: 0 }) }),
    Object.freeze({ id: 'H3', customerLabel: 'ca. 2,4 m', counts: Object.freeze({ DWETN13: 1, DWETN14: 1, DWETN15: 1 }) }),
    Object.freeze({ id: 'H4', customerLabel: 'ca. 2,6 m', counts: Object.freeze({ DWETN13: 1, DWETN14: 1, DWETN15: 2 }) }),
    Object.freeze({ id: 'H5', customerLabel: 'ca. 2,8 m', counts: Object.freeze({ DWETN13: 2, DWETN14: 0, DWETN15: 0 }) }),
    Object.freeze({ id: 'H6', customerLabel: 'ca. 3,7 m', counts: Object.freeze({ DWETN13: 3, DWETN14: 0, DWETN15: 0 }) }),
    Object.freeze({ id: 'H7', customerLabel: 'ca. 4,6 m', counts: Object.freeze({ DWETN13: 4, DWETN14: 0, DWETN15: 0 }) }),
    Object.freeze({ id: 'H8', customerLabel: 'ca. 5,6 m', counts: Object.freeze({ DWETN13: 5, DWETN14: 0, DWETN15: 0 }) }),
    Object.freeze({ id: 'H9', customerLabel: 'ca. 6,5 m', counts: Object.freeze({ DWETN13: 6, DWETN14: 0, DWETN15: 0 }) }),
    Object.freeze({ id: 'H10', customerLabel: 'ca. 7,4 m', counts: Object.freeze({ DWETN13: 7, DWETN14: 0, DWETN15: 0 }) }),
    Object.freeze({ id: 'H11', customerLabel: 'ca. 8,4 m', counts: Object.freeze({ DWETN13: 8, DWETN14: 0, DWETN15: 0 }) })
  ]);

  const HEIGHT_RECIPE_BY_ID = Object.freeze(Object.fromEntries(HEIGHT_RECIPES.map((recipe) => [recipe.id, recipe])));

  const WALL_HOLDER_BY_DISTANCE = Object.freeze({
    50: 'DWECO21',
    100: 'DWECO22',
    150: 'DWECO22',
    200: 'DWECO23',
    250: 'DWECO23',
    300: 'DWECO24',
    360: 'DWECO24'
  });

  const WALL_SUPPORT_BY_DISTANCE_AND_DN = Object.freeze({
    50: Object.freeze({ 130: 'DW391', 150: 'DW391', 160: 'DW391', 180: 'DW391', 200: 'DW391' }),
    100: Object.freeze({ 130: 'DW391', 150: 'DW391', 160: 'DW391', 180: 'DW391', 200: 'DW392' }),
    150: Object.freeze({ 130: 'DW391', 150: 'DW392', 160: 'DW392', 180: 'DW392', 200: 'DW392' }),
    200: Object.freeze({ 130: 'DW392', 150: 'DW392', 160: 'DW392', 180: 'DW392', 200: 'DW392' }),
    250: Object.freeze({ 130: 'DW392', 150: 'DW392', 160: 'DW392', 180: 'DW392', 200: 'DW393' }),
    300: Object.freeze({ 130: 'DW392', 150: 'DW393', 160: 'DW393', 180: 'DW393', 200: 'DW393' }),
    360: Object.freeze({ 130: 'DW393', 150: 'DW393', 160: 'DW393', 180: 'DW393', 200: 'DW393' })
  });

  const COMPONENT_LABELS = Object.freeze({
    DW391: 'Wandstuetze und Quertraeger Typ I',
    DW392: 'Wandstuetze und Quertraeger Typ II',
    DW393: 'Wandstuetze und Quertraeger Typ III',
    DWETN05: 'Grundplatte mit Kondensatablauf',
    DWETN10: 'Revisionselement',
    DWETN11: 'T-Anschluss 90 Grad',
    DWECO261: 'Kuerzbares Anschlusselement mit integriertem Wandfutter',
    DWETN13: 'Laengenelement 1000 mm',
    DWETN14: 'Laengenelement 500 mm',
    DWETN15: 'Laengenelement 250 mm',
    DWETN32: 'Muendungsabschluss',
    DWECO21: 'Wandhalter 50 mm',
    DWECO22: 'Wandhalter 50 bis 150 mm',
    DWECO23: 'Wandhalter 50 bis 250 mm',
    DWECO24: 'Wandhalter 250 bis 360 mm'
  });

  function defaultState() {
    return {
      system: SYSTEM_KEY,
      mounting: 'wall',
      route: 'straight-exterior-wall',
      dn: 150,
      heightClassId: 'H7',
      wallDistanceMm: 100,
      requestedFreeHeightMm: null,
      specialWindOrLoadCase: false,
      specialStatics: false,
      roofPenetration: false,
      slopedRoute: false,
      hasOffset: false,
      specialConnectionGeometry: false,
      undocumentedCombination: false
    };
  }

  function normalizeState(input) {
    const source = input || {};
    const state = Object.assign(defaultState(), source);
    state.dn = Number(state.dn);
    state.wallDistanceMm = Number(state.wallDistanceMm);
    state.heightClassId = String(state.heightClassId || '').toUpperCase();
    if (state.requestedFreeHeightMm !== null && state.requestedFreeHeightMm !== undefined && state.requestedFreeHeightMm !== '') {
      state.requestedFreeHeightMm = Number(state.requestedFreeHeightMm);
    } else {
      state.requestedFreeHeightMm = null;
    }
    return state;
  }

  function addReason(reasons, code, status, message) {
    reasons.push({ code, status, message });
    return status;
  }

  function classifyScope(state) {
    const reasons = [];

    if (state.system !== SYSTEM_KEY) {
      return {
        status: addReason(reasons, 'SYSTEM_NOT_SUPPORTED', STATUS.UNSUPPORTED, 'Only Jeremias DW-ECO 2.0 is documented in this rule set.'),
        reasons
      };
    }

    if (state.undocumentedCombination) {
      return {
        status: addReason(reasons, 'UNDOCUMENTED_COMBINATION', STATUS.UNSUPPORTED, 'The requested component or system combination is not documented for V1.'),
        reasons
      };
    }

    if (Number.isFinite(state.requestedFreeHeightMm) && state.requestedFreeHeightMm > ABSOLUTE_MAX_FREE_HEIGHT_MM) {
      return {
        status: addReason(reasons, 'FREE_HEIGHT_ABOVE_ABSOLUTE_V1_LIMIT', STATUS.UNSUPPORTED, 'Free height above 4000 mm is outside V1.'),
        reasons
      };
    }

    if (!Number.isFinite(state.dn) || (state.dn <= 200 && !PRIMARY_DNS.includes(state.dn))) {
      return {
        status: addReason(reasons, 'DN_NOT_DOCUMENTED', STATUS.UNSUPPORTED, 'The DN value is not documented for V1.'),
        reasons
      };
    }

    if (state.requestedFreeHeightMm !== null && !Number.isFinite(state.requestedFreeHeightMm)) {
      return {
        status: addReason(reasons, 'FREE_HEIGHT_INVALID', STATUS.UNSUPPORTED, 'The requested free height is not a valid millimetre value.'),
        reasons
      };
    }

    const manualReasons = [];
    if (state.dn > 200) manualReasons.push(['DN_OUTSIDE_STANDARD_RANGE', 'DN is outside the supported 130 to 200 range.']);
    if (state.mounting !== 'wall') manualReasons.push(['MOUNTING_OUTSIDE_STANDARD_PATH', 'Only wall mounting is part of the standard path.']);
    if (state.route !== 'straight-exterior-wall') manualReasons.push(['ROUTE_OUTSIDE_STANDARD_PATH', 'Only a straight exterior-wall route is part of the standard path.']);
    if (state.specialWindOrLoadCase) manualReasons.push(['SPECIAL_WIND_OR_LOAD_CASE', 'Special wind or load cases need project-specific assessment.']);
    if (state.specialStatics) manualReasons.push(['SPECIAL_STATICS', 'Special structural requirements need project-specific assessment.']);
    if (state.roofPenetration) manualReasons.push(['ROOF_PENETRATION', 'Roof penetrations are not part of the standard path.']);
    if (state.slopedRoute) manualReasons.push(['SLOPED_ROUTE', 'Sloped routes are not part of the standard path.']);
    if (state.hasOffset) manualReasons.push(['OFFSET_ROUTE', 'Offsets are not part of the standard path.']);
    if (state.specialConnectionGeometry) manualReasons.push(['SPECIAL_CONNECTION_GEOMETRY', 'Special connection geometry needs project-specific assessment.']);
    if (Number.isFinite(state.requestedFreeHeightMm) && state.requestedFreeHeightMm > MAX_FREE_HEIGHT_MM) {
      manualReasons.push(['FREE_HEIGHT_ABOVE_STANDARD_LIMIT', 'Free height above 3000 mm is not part of the standard purchase path.']);
    }

    if (manualReasons.length > 0) {
      manualReasons.forEach(([code, message]) => addReason(reasons, code, STATUS.REVIEW, message));
      return { status: STATUS.REVIEW, reasons };
    }

    if (!HEIGHT_RECIPE_BY_ID[state.heightClassId]) {
      return {
        status: addReason(reasons, 'HEIGHT_RECIPE_NOT_DOCUMENTED', STATUS.UNSUPPORTED, 'The height class is not one of the eleven confirmed recipes.'),
        reasons
      };
    }

    if (!WALL_DISTANCES_MM.includes(state.wallDistanceMm)) {
      return {
        status: addReason(reasons, 'WALL_DISTANCE_NOT_DOCUMENTED', STATUS.UNSUPPORTED, 'The wall distance is not one of the seven confirmed distances.'),
        reasons
      };
    }

    return { status: STATUS.AUTO, reasons };
  }

  function getHeightRecipe(heightClassId) {
    return HEIGHT_RECIPE_BY_ID[String(heightClassId || '').toUpperCase()] || null;
  }

  function calculateTechnicalHeightMm(dn, countsOrHeightClassId) {
    const diameter = Number(dn);
    const recipe = typeof countsOrHeightClassId === 'string'
      ? getHeightRecipe(countsOrHeightClassId)
      : null;
    const counts = recipe ? recipe.counts : countsOrHeightClassId;
    if (!Object.prototype.hasOwnProperty.call(TEE_DIMENSION_BY_DN_MM, diameter) || !counts) return null;
    return HEIGHT_CONTRIBUTIONS_MM.basePlate
      + HEIGHT_CONTRIBUTIONS_MM.inspection
      + (TEE_DIMENSION_BY_DN_MM[diameter] - HEIGHT_CONTRIBUTIONS_MM.teeSocketDeduction)
      + HEIGHT_CONTRIBUTIONS_MM.terminal
      + (HEIGHT_CONTRIBUTIONS_MM.length1000 * Number(counts.DWETN13 || 0))
      + (HEIGHT_CONTRIBUTIONS_MM.length500 * Number(counts.DWETN14 || 0))
      + (HEIGHT_CONTRIBUTIONS_MM.length250 * Number(counts.DWETN15 || 0));
  }

  function selectWallHolderFamily(wallDistanceMm) {
    return WALL_HOLDER_BY_DISTANCE[Number(wallDistanceMm)] || null;
  }

  function selectWallSupport(dn, wallDistanceMm) {
    const row = WALL_SUPPORT_BY_DISTANCE_AND_DN[Number(wallDistanceMm)];
    return row ? row[Number(dn)] || null : null;
  }

  function calculateHolderCount(technicalHeightMm, firstHolderPositionMm) {
    const height = Number(technicalHeightMm);
    const first = Number(firstHolderPositionMm);
    if (!Number.isFinite(height) || !Number.isFinite(first) || height <= first) return 0;
    return 1 + Math.max(0, Math.ceil((height - first - MAX_FREE_HEIGHT_MM) / MAX_HOLDER_SPACING_MM));
  }

  function calculateHolderPositionsMm(technicalHeightMm, firstHolderPositionMm, holderCount) {
    const height = Number(technicalHeightMm);
    const first = Number(firstHolderPositionMm);
    const quantity = Number(holderCount);
    if (!Number.isInteger(quantity) || quantity < 1 || !Number.isFinite(height) || !Number.isFinite(first)) return [];
    if (quantity === 1) return [first];

    const last = height - MAX_FREE_HEIGHT_MM;
    const upperPositions = [];
    for (let remainingIntervals = quantity - 2; remainingIntervals >= 0; remainingIntervals -= 1) {
      upperPositions.push(last - (remainingIntervals * MAX_HOLDER_SPACING_MM));
    }
    return [first].concat(upperPositions);
  }

  function buildBomBlueprint(state, recipe, holderQuantity) {
    const dn = state.dn;
    const supportSku = selectWallSupport(dn, state.wallDistanceMm);
    const holderFamily = selectWallHolderFamily(state.wallDistanceMm);
    const lines = [
      { role: 'WALL_SUPPORT', code: supportSku, sku: supportSku, quantity: 1, rule: 'WALL_SUPPORT_MATRIX' },
      { role: 'BASE_PLATE', code: 'DWETN05', sku: `205-DWETN05${dn}`, quantity: 1, rule: 'STANDARD_REQUIRED' },
      { role: 'INSPECTION', code: 'DWETN10', sku: `205-DWETN10${dn}`, quantity: 1, rule: 'STANDARD_REQUIRED' },
      { role: 'TEE_90', code: 'DWETN11', sku: `205-DWETN11${dn}`, quantity: 1, rule: 'CONFIRMED_INDIVIDUAL_COMPONENT' },
      { role: 'WALL_PASS', code: 'DWECO261', sku: `DWECO261${dn}`, quantity: 1, rule: 'FIELD_FIT_REQUIRED' },
      { role: 'LENGTH_1000', code: 'DWETN13', sku: `205-DWETN13${dn}`, quantity: recipe.counts.DWETN13, rule: recipe.id },
      { role: 'LENGTH_500', code: 'DWETN14', sku: `205-DWETN14${dn}`, quantity: recipe.counts.DWETN14, rule: recipe.id },
      { role: 'LENGTH_250', code: 'DWETN15', sku: `205-DWETN15${dn}`, quantity: recipe.counts.DWETN15, rule: recipe.id },
      { role: 'TERMINAL', code: 'DWETN32', sku: `205-DWETN32${dn}`, quantity: 1, rule: 'STANDARD_REQUIRED' },
      { role: 'WALL_HOLDER', code: holderFamily, sku: `${holderFamily}${dn}`, quantity: holderQuantity, rule: 'DISTANCE_AND_HEIGHT_RULE' }
    ];
    return lines.filter((line) => line.quantity > 0);
  }

  function lookupCatalogVariant(catalog, sku) {
    if (!catalog) return null;
    if (catalog instanceof Map) return catalog.get(sku) || null;
    return catalog[sku] || null;
  }

  function resolveConfiguration(input, catalog) {
    const state = normalizeState(input);
    const scope = classifyScope(state);
    if (scope.status !== STATUS.AUTO) {
      return {
        state,
        status: scope.status,
        scopeStatus: scope.status,
        reasons: scope.reasons,
        internalFlags: [],
        customerNotices: [],
        height: null,
        holder: null,
        bom: [],
        totalPositions: 0,
        totalComponents: 0,
        totalPriceCents: null,
        totalPriceGross: null,
        commerceStatus: 'NOT_IN_STANDARD_PATH',
        validationIssues: [],
        cartEligible: false
      };
    }

    const recipe = getHeightRecipe(state.heightClassId);
    const technicalHeightMm = calculateTechnicalHeightMm(state.dn, recipe.counts);
    const firstHolderPositionMm = T_TOP_BY_DN_MM[state.dn];
    const holderQuantity = calculateHolderCount(technicalHeightMm, firstHolderPositionMm);
    const holderPositionsMm = calculateHolderPositionsMm(technicalHeightMm, firstHolderPositionMm, holderQuantity);
    const blueprint = buildBomBlueprint(state, recipe, holderQuantity);
    const validationIssues = [];

    const bom = blueprint.map((line) => {
      const variant = lookupCatalogVariant(catalog, line.sku);
      if (!variant) validationIssues.push({ code: 'VARIANT_MISSING', sku: line.sku });
      if (variant && variant.active !== true) validationIssues.push({ code: 'PRODUCT_NOT_ACTIVE', sku: line.sku });
      if (variant && variant.buyable !== true) validationIssues.push({ code: 'VARIANT_NOT_BUYABLE', sku: line.sku });
      if (variant && (!Number.isInteger(variant.priceCents) || variant.priceCents <= 0)) validationIssues.push({ code: 'PRICE_MISSING', sku: line.sku });

      const unitPriceCents = variant && Number.isInteger(variant.priceCents) ? variant.priceCents : null;
      return {
        role: line.role,
        articleCode: line.code,
        sku: line.sku,
        system: SYSTEM_LABEL,
        dn: line.role === 'WALL_SUPPORT' ? null : state.dn,
        quantity: line.quantity,
        label: COMPONENT_LABELS[line.code] || (variant && variant.productTitle) || line.code,
        rule: line.rule,
        variantId: variant ? variant.variantId : null,
        productId: variant ? variant.productId : null,
        active: variant ? variant.active === true : false,
        buyable: variant ? variant.buyable === true : false,
        unitPriceCents,
        linePriceCents: unitPriceCents === null ? null : unitPriceCents * line.quantity
      };
    });

    const totalPriceCents = validationIssues.length === 0
      ? bom.reduce((sum, line) => sum + line.linePriceCents, 0)
      : null;
    const maxObservedSpacingMm = holderPositionsMm.length < 2
      ? 0
      : Math.max(...holderPositionsMm.slice(1).map((position, index) => position - holderPositionsMm[index]));
    const freeHeightMm = technicalHeightMm - holderPositionsMm[holderPositionsMm.length - 1];
    const internalFlags = ['FIELD_CUT_REQUIRED'];
    if (state.dn === 160) internalFlags.push('ANCHOR_LOAD_SITE_CHECK_REQUIRED');

    return {
      state,
      status: STATUS.AUTO,
      scopeStatus: STATUS.AUTO,
      reasons: scope.reasons,
      internalFlags,
      customerNotices: [
        'Das kürzbare Anschlusselement wird bei der Montage an die tatsächliche Wandsituation angepasst.',
        'Befestigungsuntergrund und Verankerung müssen projektspezifisch geprüft werden.'
      ],
      height: {
        classId: recipe.id,
        customerLabel: recipe.customerLabel,
        technicalMm: technicalHeightMm,
        counts: Object.assign({}, recipe.counts)
      },
      holder: {
        family: selectWallHolderFamily(state.wallDistanceMm),
        sku: `${selectWallHolderFamily(state.wallDistanceMm)}${state.dn}`,
        quantity: holderQuantity,
        firstReferenceMm: firstHolderPositionMm,
        positionsMm: holderPositionsMm,
        maxObservedSpacingMm,
        freeHeightMm,
        positionReference: 'ABOVE_T_TOP_REFERENCE'
      },
      bom,
      totalPositions: bom.length,
      totalComponents: bom.reduce((sum, line) => sum + line.quantity, 0),
      totalPriceCents,
      totalPriceGross: totalPriceCents === null ? null : totalPriceCents / 100,
      commerceStatus: validationIssues.length === 0 ? 'READY' : 'CATALOG_INCOMPLETE',
      validationIssues,
      cartEligible: validationIssues.length === 0 && totalPriceCents > 0
    };
  }

  function numericVariantId(variantId) {
    const value = String(variantId || '');
    return value.includes('/') ? value.split('/').pop() : value;
  }

  function buildCartPayload(result, configurationId) {
    if (!result || !result.cartEligible) throw new Error('CONFIGURATION_NOT_CART_ELIGIBLE');
    const configId = configurationId || `dw-eco-${Date.now().toString(36)}`;
    return {
      items: result.bom.map((line) => ({
        id: numericVariantId(line.variantId),
        quantity: line.quantity,
        properties: {
          '_Konfiguration': configId,
          'System': SYSTEM_LABEL,
          'Nenndurchmesser': `DN ${result.state.dn}`,
          'Hoehenklasse': result.height.customerLabel,
          'Technische Hoehe': `${result.height.technicalMm} mm`,
          'Wandabstand': `${result.state.wallDistanceMm} mm`
        }
      }))
    };
  }

  const api = Object.freeze({
    STATUS,
    SYSTEM_KEY,
    SYSTEM_LABEL,
    PRIMARY_DNS,
    WALL_DISTANCES_MM,
    MAX_HOLDER_SPACING_MM,
    MAX_FREE_HEIGHT_MM,
    ABSOLUTE_MAX_FREE_HEIGHT_MM,
    HEIGHT_CONTRIBUTIONS_MM,
    TEE_DIMENSION_BY_DN_MM,
    FIXED_HEIGHT_BY_DN_MM,
    T_TOP_BY_DN_MM,
    HEIGHT_RECIPES,
    WALL_HOLDER_BY_DISTANCE,
    WALL_SUPPORT_BY_DISTANCE_AND_DN,
    defaultState,
    normalizeState,
    classifyScope,
    getHeightRecipe,
    calculateTechnicalHeightMm,
    selectWallHolderFamily,
    selectWallSupport,
    calculateHolderCount,
    calculateHolderPositionsMm,
    buildBomBlueprint,
    resolveConfiguration,
    buildCartPayload
  });

  global.JeremiasDwEcoRules = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : globalThis);
